/**
 * Pista sincrónica de "hay sesión guardada": supabase-js persiste la
 * sesión en localStorage bajo `sb-<ref>-auth-token`. No valida nada (eso lo
 * hace `useAuth`); solo evita mostrar la landing a quien casi seguro va a
 * ser redirigido al dashboard, y evita el loader a quien seguro no.
 */
export function hasStoredSupabaseSession(
  storage: Pick<Storage, 'length' | 'key'> | null = safeStorage(),
): boolean {
  if (!storage) return false;
  try {
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key && key.startsWith('sb-') && key.endsWith('-auth-token')) return true;
    }
  } catch {
    /* storage blocked (private mode, policies) → assume no session */
  }
  return false;
}

function safeStorage(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}
